import { render, staticRenderFns } from "./inheritorItem.vue?vue&type=template&id=46b000a4&scoped=true&"
import script from "./inheritorItem.vue?vue&type=script&lang=js&"
export * from "./inheritorItem.vue?vue&type=script&lang=js&"
import style0 from "./inheritorItem.vue?vue&type=style&index=0&id=46b000a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b000a4",
  null
  
)

export default component.exports